import {RequestFormConfig} from "../../form-config"
import resourcesSessionLoader from "../../../../../core/resources/session-loader"

export function loadFormMissingData(config:RequestFormConfig) {
    const sessionLoaderPromise = resourcesSessionLoader(findMissingData(config))
    return sessionLoaderPromise
}

function findMissingData(config:RequestFormConfig) {
    let allProjects     : ID[] = []
    let allTaskTypes    : ID[] = []
    let allUsers        : ID[] = []
    let allCustomFields : ID[] = []

    if (config.projectId)           allProjects.push(config.projectId)
    if (config.taskTypeId)          allTaskTypes.push(config.taskTypeId)
    if (config.assignToUserId)      allUsers.push(config.assignToUserId)

    _.map(config.settings?.fields, (formField:any)=>{
        // fieldId check is required because FieldsCollection.get() always returns FieldProto
        if (!gd.fields.task.get(formField.taskFieldId).fieldId) {
            allCustomFields.push(formField.taskFieldId)
        }
    })

    return gd.session.findMissing({
        users           : _.uniq(allUsers),
        taskTypes       : _.uniq(allTaskTypes),
        projects        : _.uniq(allProjects),
        customFields    : _.uniq(allCustomFields),
    })
}